import { omit } from 'lodash';
import { ILegalEntityDTO, IPersonDto } from '@qwealth/qdata';
import { CreateEntityForm } from 'data/models/CreateEntityForm';

export const cleanupEntityPayload = (values: CreateEntityForm): Partial<ILegalEntityDTO> => {
  const omittedPaths = ['selectedHousehold'];
  if (!values.controllingParty) {
    omittedPaths.push('controllingParty');
    omittedPaths.push('controllingPartyAuthorizedType');
  }
  return {
    ...omit(values, omittedPaths),
    name: values.name!,
    entityType: values.entityType!,
    partnerID: values.partnerID!,
    ownership: [],
    BIN: values.BIN,
    nbinBankAccountDetails: [],
    regulatory: [],
  };
};

export const getContactOrEntityName = (client: ILegalEntityDTO | IPersonDto): string => {
  return 'name' in client ? client.name : `${client.firstName} ${client.lastName}`;
};
